import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { Divider, TextField, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import env from "react-dotenv";
import Stack from '@mui/material/Stack';
import {
  randomId
} from '@mui/x-data-grid-generator';
import moment from "moment";
import Slider from '@mui/material/Slider';

import Modal from '@mui/material/Modal';
import { CloseRounded } from "@mui/icons-material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};


const Add = ({open , onClose}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState({});
  const [date, setDate] = useState(moment(new Date()).format("yyyy-MM-dd").toString());
  const [monthyear, setMonthYear] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isSaving, setIsSaving] = useState(false);
  const submitLockRef = useRef(false);
  const [record, setRecord] = useState({
    YearMonth: "",
  });

  
  const location = useLocation();
  useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );

  const [data, setData] = useState({

    YearMonth: "",
    ABPB: "0",
    BJRL: "",
    BJTL: "",
    PBS: "",
    RPPS: "",
    RPLBS: "",
    LBS: "",
    TCEJ : "",
    RS: "",
    MEP:"",
  });

 

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
   
  }

  const handleSubmitOnDB = async (e) => {
    e.preventDefault();
    if (isSaving || submitLockRef.current) {
      return;
    }

    const newErrors = validateForm(data);

    if(monthyear !== null){
      
      record["YearMonth"] = moment(new Date(monthyear)).format("MMM-yyyy").toString();
      const exists = await getYearMonthFromDB();
      if(exists > 0){
        newErrors.YearMonth = "YearMonth already exists";        
      }    
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      // Form submission logic here
      // Object.keys(data).map((item) => (
      //   (() => {
      //     switch(item) {
      //       case "id": data['id'] = "mis"+Math.floor(Math.random() * 100000)
           
      //       default: console.log("1");
      //     }
      //   })()
      // ))
      if(monthyear !== null){
        data['YearMonth'] = moment(new Date(monthyear)).format("MMM-yyyy").toString()
      }
      try { 
        submitLockRef.current = true;
        setIsSaving(true);
      
        const res = await fetch(
          `${process.env.REACT_APP_MISBACKEND_URL}/rejection`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
        onClose();
       
        navigate("../efficiencyHome/4");        
        navigate(0);
      } catch (error) {
        console.log(error);
      } finally {
        submitLockRef.current = false;
        setIsSaving(false);
      }
    } else {
        console.log(`Form submission failed
        due to validation errors.`);
    }   
  };

  
  const validateForm = (data) => {
      const errors = {};
    //   if (data.WorkType.trim() == 'Machine Maintenance' && !data.Machine.trim()) {
    //       errors.Machine = 'Machine is required if worktype is machine maintenance';
    //       console.log(errors.Machine);
    //   }
      return errors;
  };
  const style = {
    position: 'absolute',
    top: '55%',
    left: '60%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    border: '2px solid #555',
    boxShadow: 24,
    p: 4,
  };

  
  const getYearMonthFromDB = async () => {
    try { 
       const resSlip = await fetch(
         `${process.env.REACT_APP_MISBACKEND_URL}/rejectionYearMonth`,
         {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: JSON.stringify(record),
         }
       );
       const response = await resSlip.json();
      
       return response.length;
     } catch (error) {
       console.log(error);
     }
   } 

  function Bar() {
    return (
      <Box
        sx={{
          height: 2,
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0)'
              : 'rgb(0, 0, 0, 0)',
        }}
      />
    );
  } 

  const modalStyle1 = {
    maxWidth: 600,marginLeft:"330px", marginTop:"50px",height:"300px"
      // overflow:'scroll',
    };
  
  return (open) ? (
    <Modal style={modalStyle1} className="outer1" open={open} onClose={onClose}>
    <div style={{ width: "100%", 
          borderColor: colors.blueAccent[300],border: '1px solid',
              p: 1,backgroundColor: colors.primary[400],
              borderRadius: 1}}  >
    <button className="addButton" onClick={() => onClose()}><CloseRounded/></button>
 
    <form style={{ marginLeft:"5px",marginRight:"5px",marginTop:"5px",
          marginBottom:"5px",
          borderColor: '#E0E0E0',
              p: 2,
              borderRadius: 1}} onSubmit={handleSubmitOnDB}>
            <h5 style={{ color: 'black', marginTop:"15px"}}  className="text-center">Add Rejection Record</h5>
            <Divider  sx={{       
              border: '1px solid',
              borderColor: colors.grey[200]
            
            }}/>  
            <Bar/>
            {/* <label hidden htmlFor="id" className="form-label">
                id
            </label>
            <input type="hidden" name="id"/>       */}
            <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(1, 2fr)', gap: 2 ,m:1}}>
                <Item>
                  <FormControl size="medium" fullWidth>
                  <label>YearMonth</label>
                  <DatePicker
                    disabledKeyboardNavigation
                    showMonthYearPicker
                    required
                    name="YearMonth"
                    selected={monthyear}          
                    className="dPick"
                    popperProps={{
                      positionFixed: true // use this to make the popper position: fixed
                    }}                    
                      autoComplete="off"        
                      onChange={(monthyear) => setMonthYear(new Date(monthyear))}
                      dateFormat="MMM-yyyy"
                    />
                     {errors.YearMonth &&
                      <span style={{ color: 'red'}} className="error-message">
                          {errors.YearMonth}
                      </span>
                    }
                  <Bar/>
                  </FormControl>
                </Item>
            </Box>
            <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
                <Item >
                <FormControl size="medium" fullWidth>
                       
                        <label>ABPB</label>
                        <TextField size="small"  name="ABPB"  type="number" onChange={handleChange} variant="outlined" />
                        <Bar/>

                        <label>BJRL</label>
                        <TextField size="small"  name="BJRL" type="number" onChange={handleChange} variant="outlined" />
                        <Bar/>

                        <label>BJTL</label>
                        <TextField size="small"  name="BJTL" type="number" onChange={handleChange}  variant="outlined" />
                        <Bar/>

                        <label>PBS</label>
                        <TextField size="small"  name="PBS" type="number" onChange={handleChange} variant="outlined" />
                        <Bar/>

                        <label>RPPS</label>
                        <TextField size="small"  name="RPPS" type="number" onChange={handleChange}  variant="outlined" />
                        <Bar/>
                    </FormControl>
                </Item>
                <Item >
                    <FormControl size="medium" fullWidth>
                       
                        <label>RPLBS</label>
                        <TextField size="small"  name="RPLBS" type="number" onChange={handleChange}  variant="outlined" />
                        <Bar/>

                        <label>LBS</label>
                        <TextField size="small"  name="LBS" type="number" onChange={handleChange} variant="outlined" />
                        <Bar/>

                        <label>TCEJ</label>
                        <TextField size="small"  name="TCEJ" type="number" onChange={handleChange} variant="outlined" />
                        <Bar/>

                        <label>RS</label>
                        <TextField size="small"  name="RS" type="number" onChange={handleChange}  variant="outlined" />
                        <Bar/>

                        <label>MEP</label>
                        <TextField size="small"  name="MEP" type="number" onChange={handleChange} variant="outlined" />
                        <Bar/>

                    </FormControl>
                </Item>
            </Box>
            <Box   sx={{marginTop:'10px',marginBottom:'10px',  display: 'flex',  justifyContent: 'center', padding:'1px'}}>
                <Stack spacing={2} direction="row">
                    
                    <button  class="btn btn-primary centre" >Save</button>
                
                </Stack>
            </Box>
        </form>
      </div>    
    </Modal>
    
  ): ""
};

export default Add;